import React, { useEffect } from "react";
import "../style/ToastPop.css";

const ToastPop = ({ message, redirect = "/" }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = redirect;
    }, 5000);

    return () => clearTimeout(timer);
  }, [redirect]);

  return (
    <div className="toast fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="toast-content bg-green-500 text-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-lg font-bold">¡Gracias por contactarnos!</h2>
        <p>{message}</p>
        <small className="text-sm">Serás redirigido en 5 segundos...</small>
      </div>
    </div>
  );
};

export default ToastPop;